export const commonConfig = {
  // NOTE: Fallback values are defined in webpack.config.js
  ENV: process.env.ENV,
  SERVER_URL: process.env.SERVER_URL,
  CLIENT_APP_URL: process.env.CLIENT_APP_URL,
  ROUTER_PREFIX: process.env.ROUTER_PREFIX,
  DATE_FORMAT_FULL: 'MM/DD/YYYY hh:mma',
  DATA_FORMAT_DATE_ONLY: 'MM/DD/YYYY',
}
